module.exports = __webpack_public_path__ + "static/media/about-you-primary.2760b899.svg";